import localeConfig from '../config/locale';

const createRoute = (path: string) => {
  const locales = localeConfig.locales.join('|');

  return `/:lang(${locales})?${path}`;
};

export default createRoute;
